import React from 'react';
interface ButtonProps {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
}
export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  children,
  onClick,
  className = '',
  disabled = false
}) => {
  const baseClass = variant === 'primary' ? 'btn-primary' : 'btn-secondary';
  return <button className={`${baseClass} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`} onClick={onClick} disabled={disabled} data-id="element-44">
      {children}
    </button>;
};